import React from 'react';

const inviteExpiredPage = () => {
    return (
        <div className='w-100 d-flex justify-content-center align-items-center'>
            <h1 className='primary-header mt-5'>
                Your Link has Expired. Please contact the admin.
            </h1>
        </div>
    );
};

export default inviteExpiredPage;